var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.currViewKey,class:['page-view', {'is-pg': _vm.padding, 'is-bg': _vm.background}]},[_vm._t("default"),_c('vxe-loading',{attrs:{"modelValue":_vm.loading,"text":_vm.loadingText}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }